import axios from 'utils/axios';
import {BACKEND_URL} from "@/constants/globalConstants";
const backendBaseURL = BACKEND_URL

export async function performFilterOptions(optionName, searchQuery) {
    const response = await axios.post(backendBaseURL+"/assets/filterOption",{filterName: optionName, searchQuery});
    return response.data
}

export async function collectionPerformFilterOptions(optionName, searchQuery, clipType) {
    if(clipType === 'keymoment')
        clipType = 'key_moment'
    const response = await axios.post(`${backendBaseURL}/${clipType}/v2/collection/filterOptions`,{filterName: optionName, searchQuery});
    return response.data
}

export async function searchEvent(searchQuery, additionalFilters) {
    const response = await axios.post(`${backendBaseURL}/match/v2/search`, {additionalFilters}, {params: {search: searchQuery}})
    return response.data
}

export async function searchMatchDay(searchQuery, additionalFilters) {
    const response = await axios.post(`${backendBaseURL}/match_day/search`, {searchQuery, additionalFilters});
    return response.data
}